import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6';
import './CustomArrows.css';

export const NextArrow = ({ className, style, onClick }) => {
    return (
        <div
            className={`custom-arrow next`}
            style={{ ...style }}
            onClick={onClick}
            aria-label="Next"
        >
            <i className="bi bi-chevron-right"></i>
        </div>
    );
};

export const PrevArrow = ({ className, style, onClick }) => {
    return (
        <div
            className={`custom-arrow prev`}
            style={{ ...style }}
            onClick={onClick}
            aria-label="Previous"
        >
            <i className="bi bi-chevron-left"></i>
        </div>
    );
};
